import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useCachedMenuItems } from './useCachedData';

export const useLocalizedMenuItem = (branchId: string, itemId: string | number | undefined | null) => {
    const { t, i18n } = useTranslation();
    const { menuItems } = useCachedMenuItems({ branchId });

    const menuItem = useMemo(() => {
        if (!itemId) return null;
        return menuItems.find(mi => mi.id === itemId);
    }, [menuItems, itemId]);

    const localizedName = useMemo(() => {
        if (!menuItem) return '';
        
        if (i18n.language === 'ar' && menuItem.ar) {
            // menuItem.ar can be a string (stringified JSON) or an object (already parsed JSONB)
            let arData: any = menuItem.ar;
            
            if (typeof menuItem.ar === 'string') {
                try {
                    arData = JSON.parse(menuItem.ar);
                } catch (e) {
                    // If parsing fails, treat it as a raw string if it's not JSON
                    if (menuItem.ar.trim() !== '') return menuItem.ar;
                    return menuItem.name || '';
                }
            }

            if (arData && typeof arData === 'object' && arData.name) {
                return arData.name;
            }
        }
        if (menuItem.name && typeof menuItem.name === 'string' && menuItem.name.trim() !== '') {
            return menuItem.name;
        }
        return '';
    }, [menuItem, i18n.language]);

    return { menuItem, localizedName };
};
